import type { InterventionInfoButtonProps } from "./intervention-info-button.type";

import InfoButton from "@/components/Header/Button/InfoButton";
import InterventionInfo from "@/features/Interventions/Info";
import { useSidePanel } from "@/modules/side-panel";

export const InterventionInfoButton = ({
  intervention,
}: InterventionInfoButtonProps) => {
  const { openSidePanel } = useSidePanel();

  const onClick = () => {
    openSidePanel({
      title: intervention.name,
      component: <InterventionInfo intervention={intervention} />,
    });
  };

  return <InfoButton onInfoSelect={onClick} />;
};
